<template>
    <b-row class="calculator">
        <div class="col-2 d-none d-md-block menu-calculator"
             style="width: 88px; max-width: 88px"
        >
            <b-list-group :class="is_expanded ? 'menu-calc-expanded' : 'menu-calc'"
                          @mouseover="expandMenu"
                          @mouseout="collapseMenu"
            >
                <b-list-group-item v-for="(item, idx) in menu_items"
                                   :key="idx"
                                   :class="{
                                           'expanded-calc': is_expanded,
                                           'item-selected-calc' : selected_item === item.name,
                                           'd-flex align-items-center': true
                                         }"
                                   @click="selectItem(item)"
                >
                    <div class="float-left"
                         style="width: 38px; max-width: 38px"
                    >
                        <img :src="`./img/sga/${item.image}`"
                             class="pictogram-calc"
                             :alt="item.name"
                        />
                    </div>
                    <div class="menu-calc-text ml-3"                    >
                        {{ item.text }}
                    </div>
                </b-list-group-item>
            </b-list-group>
        </div>
        <div class="col-12 d-block d-md-none mb-2">
            <el-select id="selected_item"
                       name="selected_item"
                       v-model="selected_item"
                       size="small"
                       :clearable="false"
                       filterable
                       class="mb-2"
                       popper-class="w-100"
            >
                <el-option v-for="item in menu_items"
                           :key="item.name"
                           :label="item.text"
                           :value="item.name"
                >
                    <img :src="`./img/sga/${item.image}`"
                         class="mr-2"
                         style="width: 16px"
                         :alt="item.name"
                    />
                    {{ item.text }}
                </el-option>
            </el-select>
        </div>
        <div class="col table-responsive"
             v-for="(item, idx) in menu_items"
             :key="idx"
             v-if="selected_item === item.name"
        >
            <h2 class="title-cal mb-3 d-none d-md-block">{{ selectedItem ? selectedItem.text : '' }}</h2>
            <h5 class="title-cal mb-3 d-block d-md-none">{{ selectedItem ? selectedItem.text : '' }}</h5>
            <component v-bind:is="item.component"
                       :component="item.component"
            />
        </div>
    </b-row>
</template>

<script>

export default {
    name: 'menu',
    props: {
        menu_items: {
            required: true,
            type: Array,
            default: []
        },
        initial_item: {
            required: true,
            type: String,
            default: ''
        }
    },
    data() {
        return {
            selected_item: '',
            is_expanded: false
        };
    },
    computed: {
        selectedItem() {
            return this.menu_items.find(mi => mi.name === this.selected_item);
        }
    },
    mounted() {
        this.selected_item = this.initial_item;
    },
    methods: {
        selectItem(item) {
            this.selected_item = item.name;
            this.is_expanded = false;
        },
        expandMenu() {
            this.is_expanded = true;
        },
        collapseMenu() {
            this.is_expanded = false;
        },
    }
};
</script>

<style lang="scss">
.calculator {
    .menu-calculator .list-group-item{
        padding: 8px 10px;
    }


    .menu-calc {
        transition: width 0.1s ease;
        width: 60px;
        overflow: hidden;
        background-color: #f8f8f8;
        box-shadow: 3px 0 4px #d4d4d4;
    }

    .menu-calc-expanded {
        transition: width 0.1s ease;
        width: 350px;
        overflow: hidden;
        background-color: #f8f8f8;
        cursor: pointer;
        box-shadow: 3px 0 10px #8e8e8e;
        z-index: 100;
        position: relative;
    }

    .expanded-calc:hover {
        background-color: #c2c2c2 !important;
    }

    .item-selected-calc .menu-icon-calc {
        filter: invert(100%);
    }

    .menu-calc-expanded .expanded-calc {
        width: 350px;
        background-color: #f8f8f8;
        z-index: 100;
    }

    .menu-icon-calc {
        width: 38px;
    }

    .pictogram-calc {
        width: 38px;
    }

    .menu-calc-text {
        display: none;
    }

    .menu-calc-expanded .expanded-calc .menu-calc-text {
        display: inline;
    }

    .item-selected-calc {
        background-color: #1a94c0 !important;
        color: white;
    }

    .title-cal {
        color: #1a94c0;
    }
}
</style>
